import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { LayoutCard } from '@beef/landing-constructor';
import { compose } from '@beef/utils';
import { isEmpty } from 'lodash';
import { withAnalyticsOnBlockView } from "../hoc/withAnalyticsOnView";
import { getAboutConnectionList, getAboutConnectionTitle } from "../../store/blocks/aboutConnectionCards/selectors";
import { getAnalyticEventType } from "../../store/blocks/selectors";
import { getRegionIn } from "../../store/userRegion/selectors";
import { templateParser } from "../../utils";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
var _AboutConnectionBlock = function _AboutConnectionBlock(_ref) {
  var analyticBlockTitle = _ref.analyticBlockTitle,
    className = _ref.className,
    content = _ref.content;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "blocks-AboutConnectionBlock"
  }, /*#__PURE__*/React.createElement(LayoutCard, _extends({
    type: "infoCard"
  }, content, {
    title: analyticBlockTitle
  })));
};
var _AboutConnectionBlockHOC = withAnalyticsOnBlockView(_AboutConnectionBlock);
var mapStateToProps = function mapStateToProps(state) {
  var blockTitle = templateParser(getAboutConnectionTitle(state), {
    regionin: getRegionIn(state)
  });
  return {
    analyticBlockTitle: blockTitle,
    content: getAboutConnectionList(state),
    pageType: getAnalyticEventType(state),
    shouldRender: !isEmpty(getAboutConnectionList(state))
  };
};
export var AboutConnectionBlock = compose(defineBlock(FttbBlocks.CONNECTION_CARDS), connect(mapStateToProps))(_AboutConnectionBlockHOC);